import React, { useEffect, useState } from 'react';
import Overview from './components/Aboutus/Overview';
import BusinessEnquiry from "./components/Forms/Enquiry";
import axios from 'axios';
import { API_BASE_URL } from "./Utils/useApi";
import { CircularProgress } from "@mui/material";
import { useParams, useNavigate } from 'react-router-dom';
import './components/Aboutus/index.css';
import BreadCrumbs from './components/BreadCrumb/Index';

const Servicedetails = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!slug) {
          navigate('/our-services');
          return;
        }

        const response = await axios.get(
          `${API_BASE_URL}/what_we_do_details.php?slug=${slug}`
        );

        // If response data is empty or invalid, redirect
        if (!response.data || !response.data.homeBanners || !response.data.overview) {
          navigate('/our-services');
          return;
        }

        setPageData(response.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching service details:", err);
        navigate('/what-we-do');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug, navigate]);

  if (loading) {
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  }
  if (error) {
    return (
      <div>Error: An error occurred while fetching data</div>
    );
  }

  const { overview, serviceContent } = pageData;

  return (
    <main>
      <BreadCrumbs />
      {overview && <Overview Data={overview} serviceDetail={true} serviceContent={serviceContent} _class={'text-lg-center text-start'} />}

      <BusinessEnquiry />
    </main>
  );
};

export default Servicedetails;
